import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      <p className="github">
        <a rel="noopener noreferrer" href="https://github.com/ch90331/weather-reactapp" target="_blank">
          Open-source code
        </a>
        {" "} on GitHub by Ya-Ju Yu
      </p>
    </div>
  );
}
